import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7ce45a90"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "breadcrumbs"
}
const _hoisted_2 = { class: "flex align-items-center gutter-x-s2" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-chevron-right ml-s2 text-xs" }, null, -1))
const _hoisted_4 = { class: "breadcrumb-item current" }
const _hoisted_5 = { class: "breadcrumb-item-text" }

import { computed } from 'vue';
import { useRouter } from 'vue-router';
import { ROUTE, ROUTE_NAMES } from '@/constants/PAGE_ROUTES';
import { useI18n } from 'vue-i18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'Breadcrumbs',
  setup(__props) {

const router = useRouter();
const { t } = useI18n();

const labelFromRouteName = name => {
  return t(`mainMenu.${name.toString().charAt(0).toLowerCase() + name.toString().slice(1)}`);
};
const currentRouteName = computed(() => router.currentRoute.value.name ?? '');
const currentRouteLabel = computed(() => labelFromRouteName(currentRouteName.value));

const breadcrumbs = [
  {
    name: ROUTE_NAMES.SINGLE_SIDE,
    items: [{ label: labelFromRouteName(ROUTE_NAMES.PORTFOLIOS), to: ROUTE.PORTFOLIOS }],
  },
];

const items = computed(
  () => breadcrumbs.find(item => item.name === currentRouteName.value.toString())?.items,
);

const goToPage = path => {
  router.push(path);
};

return (_ctx: any,_cache: any) => {
  const _component_Button = _resolveComponent("Button")!

  return (_unref(items))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(items), (item) => {
            return (_openBlock(), _createElementBlock("div", {
              key: item.label,
              class: "breadcrumb-item"
            }, [
              _createVNode(_component_Button, {
                class: "button-plain breadcrumb-item-text",
                onClick: ($event: any) => (goToPage(item.to))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(item.label), 1)
                ]),
                _: 2
              }, 1032, ["onClick"]),
              _hoisted_3
            ]))
          }), 128)),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(currentRouteLabel)), 1)
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})